const initialState = {
  auction: {},
  global: [],
  interactive: []
}

const hideByKey = (notificationsToIterate, key) => notificationsToIterate
  ? notificationsToIterate.map(notification => notification.key === key
    ? Object.assign({}, notification, {
      visible: false
    })
    : notification)
  : []

const hideAll = (notificationsToIterate) => {
  const storedInteractiveNotifications = localStorage.getItem('interactiveNotifications')
  if (storedInteractiveNotifications) {
    localStorage.removeItem('interactiveNotifications')
  }
  return notificationsToIterate.map(notification => Object.assign({}, notification, {
    visible: false
  }))
}

export default function notifications (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case 'AUCTION_NOTIFICATION_ADDED': {
      const notification = {
        listingUuid: action.listingUuid,
        icon: action.icon,
        message: action.message,
        type: action.notificationType,
        visible: true,
        key: `${action.listingUuid}-${Date.now()}`
      }
      return Object.assign({}, state, {
        auction: Object.assign({}, state.auction, {
          [action.auctionUuid]: state.auction[action.auctionUuid]
            ? [notification, ...state.auction[action.auctionUuid]]
            : [notification]
        })
      })
    }

    case 'AUCTION_NOTIFICATION_REMOVED':
      return Object.assign({}, state, {
        auction: Object.assign({}, state.auction, {
          [action.auctionUuid]: hideByKey(
            state.auction[action.auctionUuid],
            action.key
          )
        })
      })

    case 'GLOBAL_NOTIFICATION_ADDED': {
      const notification = {
        icon: action.icon,
        message: action.message,
        type: action.notificationType,
        pageNeedsRefreshing: action.pageNeedsRefreshing,
        hasTimer: action.hasTimer,
        visible: true,
        key: Date.now().toString()
      }
      return Object.assign({}, state, {
        global: [notification, ...state.global]
      })
    }
    case 'GLOBAL_NOTIFICATION_REMOVED':
      return Object.assign({}, state, {
        global: hideByKey(state.global, action.key)
      })

    case 'INTERACTIVE_NOTIFICATION_ADDED': {
      const notification = {
        listingUuid: action.listingUuid,
        type: action.notificationType,
        visible: true,
        key: `${action.listingUuid}-${Date.now()}`
      }
      return Object.assign({}, state, {
        interactive: [notification, ...state.interactive]
      })
    }

    case 'INTERACTIVE_NOTIFICATION_REMOVED': {
      return Object.assign({}, state, {
        interactive: hideAll(state.interactive)
      })
    }

    default:
      return state
  }
}
